import React, { useRef, useState } from 'react';

import { addNewCart } from 'features/shoppingCart/shoppingCartSlice';
import { useThunkDispatch } from 'hooks';
import { useTranslation } from 'react-i18next';

import { Button, ClickAwayListener, Grow, Paper, Popper, TextField } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(1),
    },
  }),
);

interface Props {
  iconProps: {
    className: string;
  };
}

export default ({ iconProps }: Readonly<Props>) => {
  const classes = useStyles();
  const { t } = useTranslation('cart');
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const dispatch = useThunkDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleToggle}
        aria-owns="create-new-cart"
        aria-haspopup="true"
        ref={anchorRef}
      >
        {t('new_cart')}
        <AddIcon {...iconProps} />
      </Button>
      <Popper open={open} anchorEl={anchorRef.current} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper className={classes.paper} id="create-new-cart">
              <ClickAwayListener onClickAway={handleClose}>
                {/* div can't be a fragment or ClickAwayListener fails silently */}
                <form
                  onSubmit={(e) => {
                    e.preventDefault();

                    const target = e.target as typeof e.target & {
                      newCart: { value: string };
                    };

                    handleClose();
                    dispatch(addNewCart(target.newCart.value));
                  }}
                >
                  <TextField inputProps={{ maxLength: 18 }} name="newCart" autoFocus required />
                </form>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
